import React from 'react';
import FieldCheckbox from '../fields/FieldCheckbox';
import FieldSelect from '../fields/FieldSelect';
import FieldCustomSelect from '../fields/FieldCustomSelect';
import FieldTextarea from '../fields/FieldTextarea';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
import DevWarning from '../common/DevWarning';
import { __currencyDisplay } from '../../_utils';
import { getFieldStatusProps } from '../../selectors/defaultSelectors';

const FORM_LABEL = {
    ShippingID: getTranslation('FIELD.DELIVERY_OPTION'),
    UrgentDelivery: getTranslation('FIELD.URGENT_DELIVERY_PRIORITISATION'),
    Notes: getTranslation('FIELD.ADDITIONAL_DELIVERY_NOTES'),
};

const getCustomSelectDeliveryOptions = (deliveryOptions) => {
    let deliveryOptionsForSelect;
    let placeholderSelectLabel = getTranslation('SELECT_DELIVERY_OPTION');
    const deliveryOptionsArr = Object.values(deliveryOptions);

    const highestDiscountValue = deliveryOptionsArr.reduce(
        (maxDiscount, node) => {
            const { Discount } = node;

            if (Discount === null) {
                return maxDiscount;
            }

            if (maxDiscount === null) {
                return Number(Discount);
            } else {
                return Math.max(Number(Discount), maxDiscount);
            }
        },
        null
    );

    if (highestDiscountValue !== null) {
        placeholderSelectLabel = `${placeholderSelectLabel} <div class="checkout-delivery-label">${highestDiscountValue}% ${getTranslation(
            'FIELD.OFF_SHIPPING_AVAILABLE'
        )}</div>`;
    }

    // Add the select on top
    deliveryOptionsForSelect = [
        {
            label: placeholderSelectLabel,
            value: 0,
        },
    ];

    // now the rest
    deliveryOptionsForSelect.push(
        ...deliveryOptionsArr.map((item) => {
            const { Title, DisplayTotal, DiscountedTotal } = item;
            let finalText;

            if (DiscountedTotal !== null) {
                finalText = `${Title} - <s>${__currencyDisplay(
                    DisplayTotal
                )}</s> ${__currencyDisplay(DiscountedTotal)}`;
            } else {
                finalText = `${Title} - ${__currencyDisplay(DisplayTotal)}`;
            }

            return {
                label: finalText,
                value: item.FakeID,
            };
        })
    );

    return deliveryOptionsForSelect;
};

function CheckoutDeliveryOptions(props) {
    const {
        fieldRefs,
        isLoading,
        formData,
        fieldStatus,
        handleFormUpdate,
        handleFormUpdateNumber,
        deliveryOptions,
        hasUrgentDelivery,
        memberType,
        updateField,
    } = props;

    const deliveryOptionList = getCustomSelectDeliveryOptions(deliveryOptions);

    return (
        <React.Fragment>
            <div className='card__header'>
                <span className='card__header-wrapper'>
                    <span className='card__header-icon'>
                        <i className='icon icon-delivery' />
                    </span>
                </span>
                <h5 className='heading--lv5 heading'>
                    <LocalizedMessage id={'FIELD.FREIGHT_DELIVERY_OPTION'} />
                </h5>
            </div>
            <div className='card__content'>
                {window.localeCountry == 'South Africa' && window.currentOrderPaymentMethod ==
                'order-card-authorization-payfast' &&
                window.isEditOrder ? (
                    <div className='notice'>
                        <div className='payment-tabs__content vspace vspace--smaller'>
                            {window.currentOrderFormattedShippingTotal}
                        </div>
                    </div>
                ) : (
                    <FieldCustomSelect
                        required
                        ref={(r) => (fieldRefs.DeliveryAddressID = r)}
                        className='field--filled'
                        isMulti={false}
                        isSearchable={true}
                        isClearable={false}
                        limit={1}
                        isLoading={isLoading.deliveryOptions}
                        label={FORM_LABEL['ShippingID']}
                        animatedLabel={FORM_LABEL['ShippingID']}
                        name='ShippingID'
                        options={deliveryOptionList}
                        value={formData.ShippingID || 0}
                        onChange={(name, value) => updateField(name, value)}
                        {...getFieldStatusProps(fieldStatus, 'ShippingID')}
                    />
                )}
                {/*
                <FieldSelect
                    required
                    isLoading={isLoading.deliveryOptions}
                    label={FORM_LABEL['ShippingID']}
                    animatedLabel={FORM_LABEL['ShippingID']}
                    name='ShippingID'
                    options={deliveryOptionsForSelect}
                    value={formData.ShippingID}
                    onChange={handleFormUpdate}
                    {...getFieldStatusProps(fieldStatus, 'ShippingID')}
                />
                */}

                {hasUrgentDelivery === true && (
                    <React.Fragment>
                        <DevWarning>
                            <p>
                                <LocalizedMessage
                                    id={
                                        'FIELD.URGENT_DELIVERY_PRIORITISATION_WARNING'
                                    }
                                />
                            </p>
                        </DevWarning>
                        <div className='form__highlight form__highlight--additional'>
                            <FieldCheckbox
                                checked={formData.UrgentDelivery == 1}
                                label={FORM_LABEL['UrgentDelivery']}
                                name='UrgentDelivery'
                                value={formData.UrgentDelivery == 1 ? 0 : 1}
                                onChange={handleFormUpdateNumber}
                            />
                            <span className='field__value field__value--right'>
                                + {__currencyDisplay('100')}
                            </span>
                        </div>
                    </React.Fragment>
                )}

                <FieldTextarea
                    label={FORM_LABEL['Notes']}
                    animatedLabel={FORM_LABEL['Notes']}
                    name='Notes'
                    value={formData.Notes || ''}
                    onChange={handleFormUpdate}
                />
                {isLoading.deliveryOptions === true && (
                    <React.Fragment>
                        <div className='notification'>
                            <div className='text-box'>
                                <p>
                                    <strong>Please wait, </strong>Freight
                                    calculation in progress{' '}
                                </p>
                            </div>
                        </div>
                    </React.Fragment>
                )}
            </div>
        </React.Fragment>
    );
}

export default CheckoutDeliveryOptions;
